import * as React from "react";
import { atom, useAtom, useAtomValue } from "jotai";
import { shopRouteOfPath } from "../../shared/shops/dashboardPath.js";
import { withIncludes, Influencer } from "../domain";
import { useCurrentUser } from "../globalState";
import { writeTabRoute } from "./tabShop";
import useStartingShop from "../hooks/useStartingShop";

const activeInfluencerAtom = atom(null);
const enrichInfluencer = (influencer) =>
  withIncludes(Influencer.from(influencer));

export function useActiveInfluencerWithSetter() {
  const [influencer, setInfluencer] = useAtom(activeInfluencerAtom);

  const setActiveInfluencer = React.useCallback(
    (raw) => setInfluencer(raw ? enrichInfluencer(raw) : null),
    [setInfluencer],
  );

  const mutateActiveInfluencer = React.useCallback(
    (mutator) =>
      setInfluencer((prev) =>
        prev?.raw ? enrichInfluencer(mutator(prev.raw())) : prev,
      ),
    [setInfluencer],
  );

  return React.useMemo(
    () => ({
      activeInfluencer: influencer,
      setActiveInfluencer,
      mutateActiveInfluencer,
    }),
    [influencer, setActiveInfluencer, mutateActiveInfluencer],
  );
}

export function useActiveInfluencer() {
  return useAtomValue(activeInfluencerAtom);
}

const canHaveShops = (user) =>
  Boolean(
    user.email &&
      (user.isAdmin ||
        user.isSuperadmin ||
        (user.isNotJustCustomer && (user.shops?.length ?? 0) > 0)),
  );

function StartingShopLoader() {
  const [influencer, setInfluencer] = useAtom(activeInfluencerAtom);
  const { shop } = useStartingShop({ enabled: !influencer });

  React.useEffect(() => {
    if (shop) setInfluencer((current) => current ?? enrichInfluencer(shop));
  }, [shop, setInfluencer]);

  return null;
}

function TabShopRecorder() {
  const route = useAtomValue(activeInfluencerAtom)?.route;

  React.useEffect(() => {
    if (route) writeTabRoute(route.toLowerCase());
  }, [route]);

  return null;
}

export default function StartingShop() {
  const [opensOnShop] = React.useState(() =>
    Boolean(shopRouteOfPath(window.location.pathname)),
  );

  return canHaveShops(useCurrentUser()) ? (
    <>
      <TabShopRecorder />
      {!opensOnShop && <StartingShopLoader />}
    </>
  ) : null;
}
